export default class PromotionManagementEvents {
    public static gridRefreshEvent = "PromotionManagementGridRefresh";
    public static promotionItemGridRefreshEvent = "PromotionItemGridRefresh";
    public static promotionUpsellGridRefreshEvent =
        "PromotionUpsellGridRefresh";
    public static trackingCodeGridRefreshEvent = "TrackingCodeGridRefresh";
}
